import { createFilter } from "@jsq/ds/refilterable";
import { toGlobalId } from "common/helpers/globalId";

export const SEPARATOR = "~";

export function parseInput(input = "", objectTypeName: string, separator = SEPARATOR) {
  return input
    .split(separator)
    .filter((id) => !Number.isNaN(parseInt(id, 10)))
    .map((id) => toGlobalId(objectTypeName, id));
}

export const arenaId = createFilter<number>("arena_id", {
  parse: (input) => parseInt(input, 10),
  format: (value) => String(value),
  defaultValue: undefined,
  validate: (input, parse) => {
    const result = parse(input);
    return result ? result >= 0 : false;
  },
});
